import Frog from '@yuanfudao/frog'
import QueryUtil from '../utils/QueryUtil'
import Utils from '../utils/Utils'

const appendCommonKV = (keyValues) => {
  const search = QueryUtil.search()
  console.log('search++', search)
  keyValues.push({ key: 'from', value: search.from || '' })
  keyValues.push({ key: 'appId', value: Utils.getAppId() })
  return keyValues
}

const install = (Vue, options) => {
  Vue.prototype.$addFrog = function (url, params) {
    let keyValues = []
    params = params || {}
    Object.keys(params).forEach((key) => {
      const value = params[key]
      keyValues.push({ key, value })
    })
    appendCommonKV(keyValues)
    if (window.ytkUserId) {
      options.fields.userId = window.ytkUserId
    }
    if (window.solarUserId) {
      options.fields.solarUserId = window.solarUserId
    }
    let extensions = []
    if (options.fields.solarUserId) {
      extensions.push({
        key: 'solarUserId',
        value: options.fields.solarUserId
      })
    }
    console.log({ ...options.fields, keyValues, extensions })
    const ins = new Frog({ ...options.fields, keyValues, extensions })
    ins.clear()
    ins.add(url)
    ins.send()
  }
}

export default { install }



// WEBPACK FOOTER //
// ./src/plugins/frog.js